import { DarkCustomizations } from '@uifabric/theme-samples';
import { Theme } from '@fluentui/theme';

export const DarkTheme: Theme = DarkCustomizations.settings.theme;
